import { ApolloLink } from '@apollo/client';
import { persistedQueryLink } from './persistedQueryLink';
import { readSessionLink } from './readSessionLink';
import { logoutLink } from './logoutLink';
import { cleanTypenameLink } from './cleanTypenameLink';
import { requiresAuthMiddleware } from './requiresAuthLink';
import { createTransportLink } from './transportLink';
import { precacheLink } from './precacheLink';
import { telemetryLink } from './telemetryLink';

export type LinkProps = {
  httpUri?: string;
  wsUri?: string;
};

export function createApolloLink({ httpUri, wsUri }: LinkProps = {}) {
  return ApolloLink.from([
    persistedQueryLink,
    readSessionLink,
    telemetryLink,
    logoutLink,
    cleanTypenameLink,
    precacheLink,
    requiresAuthMiddleware,
    createTransportLink({ httpUri, wsUri }),
  ]);
}
